import {FormEventHandler, forwardRef, useEffect} from 'react'

import cn from 'classnames/bind'

import MobxDragFile from 'components/elements/fields/MobxDragFile'
import MobxSelect from 'components/elements/fields/MobxSelect'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {Col, Row} from 'components/elements/grid'
import usStates from 'src/configs/usStates'
import {posthogTrack} from 'src/utils'
import {useAuthStore, usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubCompanyInfoNew.module.scss'

const cx = cn.bind(s)

interface IFieldsPayStubCompanyInfoProps {
	className?: string
	handleFormData?: () => void
	onChange?: FormEventHandler<HTMLDivElement>
}

const FieldsPayStubCompanyInfoNew = forwardRef<HTMLDivElement, IFieldsPayStubCompanyInfoProps>(
	({className, ...props}, ref) => {
		const payStubStore = usePayStubStore()
		const authStore = useAuthStore()

		useEffect(() => {
			if (!authStore.hasActiveSubscription) {
				posthogTrack(`[PAYSTUB unsubscribed] Step 3 started`)
			}
		}, [authStore.hasActiveSubscription])

		useEffect(() => {
			posthogTrack(`[PAYSTUB] Step 3 started`)
		}, [])

		return (
			<div className={cx('company', className)} data-testid="company-info" {...props} ref={ref}>
				<div className={cx('company--fields')}>
					<Row className={cx('company__row')}>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'Employer (Company) name'}
								placeholder="Enter the Name"
								store={payStubStore.companyInfo}
								name="employerName"
								required
								variant="new"
								size="large"
							/>
						</Col>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'Employer telephone number'}
								placeholder="123-456-7890"
								store={payStubStore.companyInfo}
								name="employerTelephone"
								variant="new"
								size="large"
							/>
						</Col>
					</Row>
					<MobxTextInput
						wrapperClassName={cx('field')}
						label={'Street address 1'}
						placeholder="Your Employer Address"
						store={payStubStore.companyInfo}
						name="streetAddress1"
						required
						variant="new"
						size="large"
					/>
					<MobxTextInput
						wrapperClassName={cx('field')}
						label={'Street address 2'}
						placeholder="Suite 1234"
						store={payStubStore.companyInfo}
						name="streetAddress2"
						variant="new"
						size="large"
					/>
					<MobxSelect
						name="state"
						placeholder="Choose state"
						label="State"
						store={payStubStore.companyInfo}
						wrapperClassName={cx('field')}
						required
						data-testid="state"
						variant="new"
						size="large"
						options={usStates}
					/>
					<Row className={cx('company__row')}>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'City'}
								placeholder="Your Employer City"
								store={payStubStore.companyInfo}
								name="city"
								required
								variant="new"
								size="large"
							/>
						</Col>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'Zip code'}
								placeholder="12345"
								store={payStubStore.companyInfo}
								name="zipCode"
								required
								variant="new"
								size="large"
								maxLength={5}
							/>
						</Col>
					</Row>
					<MobxDragFile
						name="payrollLogo"
						store={payStubStore.companyInfo}
						className={cx('field')}
						label="Payroll processor logo"
					/>
					<MobxDragFile
						name="employerLogo"
						store={payStubStore.companyInfo}
						className={cx('field')}
						label="Employer logo"
					/>
				</div>
			</div>
		)
	},
)

FieldsPayStubCompanyInfoNew.displayName = 'FieldsPayStubCompanyInfo'

export default FieldsPayStubCompanyInfoNew
